import React from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { AlertTriangle } from "lucide-react";

const DeceasedConfirmationView = ({
  userData,
  isAdminMode,
  onReturnToAdmin,
  onExit,
}) => {
  return (
    <div className="p-4 md:p-4 bg-gradient-to-br from-slate-50 via-amber-50 to-slate-100 w-full">
      <div className="max-w-3xl mx-auto">
        <Card className="p-10 shadow-2xl border-0 bg-white/95 backdrop-blur-sm text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-6">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
          </div>
          <h2 className="text-2xl font-semibold text-slate-800 mb-4">
            Atenção: Substituído Falecido
          </h2>
          <p className="text-slate-700 mb-8">
            O cadastro foi salvo, mas como o substituído é falecido, é necessário que os herdeiros entrem em contato diretamente com o departamento jurídico do sindicato para dar continuidade ao processo.
          </p>
          {!isAdminMode && (
            <p className="text-slate-700 mb-8">
              Para mais informações, entre em contato com: (11) 93333-3012
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {isAdminMode ? (
              <Button onClick={onReturnToAdmin} className="h-11 px-6">
                Voltar ao Painel de Admin
              </Button>
            ) : (
              <Button onClick={onExit} className="h-11 px-6">
                Sair do Sistema
              </Button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DeceasedConfirmationView;
